var React = require('react');

function ListSnowbird (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m.1.1l-.1.2,79.2,85.9h.2v-51.5c0-4.1-1.2-10.9-4.7-17-1.5-2.5-3.4-4.9-5.6-7.1l-2.4-2.1C60.3,2.8,51.2.2,43.2,0L.1.1h0Z"}));
}

ListSnowbird.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 79.4 86.2"};

module.exports = ListSnowbird;

ListSnowbird.default = ListSnowbird;
